import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Toast } from "src/hooks/toast";
import { confirmService } from "src/hooks/confirmHook";

const MUTATION = gql`
  mutation supplierMassUpdatePriceDiscountItem($data: [ProductUpdateItem]!) {
    supplierMassUpdatePriceDiscountItem(data: $data)
  }
`;

export function ProductUploadExcel() {
  let refInput: any;
  const [supplierMassUpdatePriceDiscountItem] = useMutation(MUTATION, {
    refetchQueries: ["supplierProductRequestList"],
    onCompleted: (res) => {
      if (res.supplierMassUpdatePriceDiscountItem) {
        Toast.onShow(
          "mass update all product price discount and discontinue follow by your excel.",
          "success",
          "right",
        );
      }
    },
  });

  const handleClick = () => {
    refInput.click();
  };

  const handleChange = (e: any) => {
    const file = e.target.files[0];
    confirmService
      .show({
        message: "Are you sure update price discount and discontinue follow by excel?",
      })
      .then((res) => {
        if (res) {
          const read = new FileReader();
          read.onload = () => {
            import("xlsx").then((XLSX) => {
              const excel = XLSX.read(read.result, { type: "binary" });
              const sheet = excel.Sheets[excel.SheetNames[0]];
              const data = XLSX.utils.sheet_to_json(sheet).map((item: any) => {
                return {
                  itemid: item["Item ID"],
                  price: Number(item["Sale Price"] ? item["Sale Price"] : 0),
                  discount: Number(item["Discount (%)"] ? item["Discount (%)"] : 0),
                  discontinue: Number(item["Discontinue"] ? item["Discontinue"] : 0),
                };
              });

              supplierMassUpdatePriceDiscountItem({
                variables: {
                  data,
                },
              });
            });
          };
          read.readAsBinaryString(file);
        }
      });
  };

  return (
    <span>
      <input type="file" value="" style={{ display: "none" }} ref={(e) => (refInput = e)} onChange={handleChange} />
      <button className="btn btn-primary btn-sm ml-1" onClick={handleClick}>
        Upload Excel
      </button>
    </span>
  );
}
